import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-w', 'IconLetterW', [["path",{"d":"M4 4l4 16l4 -14l4 14l4 -16","key":"svg-0"}]]);